// A native select in the kit's field box. The kit has no select of its own
// (FieldTrigger is a trigger, with no menu), and a native one keeps the
// platform's keyboard and option list. Recorded in design/MISSING.md.

import type { ReactNode, SelectHTMLAttributes } from "react";
import { cx } from "../kit/kit-state";

export interface FieldSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** The accessible name. A select beside a row label has no <label> of its own. */
  label: string;
  /** This value was moved off its default. Draws the brand edge. */
  overridden?: boolean;
  children: ReactNode;
}

export function FieldSelect({ label, overridden, className, disabled, children, ...rest }: FieldSelectProps) {
  return (
    <div
      className={cx("k-field upm-select", className)}
      data-overridden={overridden ? "true" : undefined}
      data-state={disabled ? "disabled" : undefined}
    >
      <select className="k-field__input upm-select__control" aria-label={label} disabled={disabled} {...rest}>
        {children}
      </select>
    </div>
  );
}
